export default "__VITE_ASSET__3b3fb636__"